function collectionCarousel(name, autoplay, interval) {
    document.querySelectorAll(name).forEach((carousel) => {
        var numberOfSlides = carousel.querySelectorAll('.splide__slide').length;
        var splide = new Splide(carousel, {
            pagination: false,
            arrows: false,
            autoplay: autoplay,
            interval: interval,
            // focus: 0,
            autoWidth: true,
            type: 'slide',
            gap: '1rem',
            mediaQuery: 'min',
            flickMaxPages: 1,
            rewind: true,
            rewindByDrag: true,
            perMove: 1,
            flickPower: 400,
            breakpoints: {
                0: {
                    perPage: 1
                },
                360: {
                    perPage: numberOfSlides >= 2 ? 2 : numberOfSlides,
                },
                641: {
                    perPage: numberOfSlides >= 3 ? 3 : numberOfSlides
                }
            },
            arrowPath: 'M39.6,21l-15.7,15.7c-.5.5-1.5.5-2.1,0-.5-.5-.5-1.5,0-2.1l13.3-13.3H1.4c-.8,0-1.4-.6-1.4-1.4s.6-1.4,1.4-1.4h33.7l-13.3-13.2c-.5-.5-.5-1.5,0-2.1.5-.5,1.5-.5,2.1,0l15.7,15.7c.5.5.5,1.5,0,2.1Z'
        });

        splide.on('overflow', function (isOverflow) {
            var progressBar = carousel.querySelector('.slider__progress');

            if (isOverflow) {
                // Enough slides
                progressBar?.classList.remove('hidden');
            } else {
                // Not enough slides
                progressBar?.classList.add('hidden');
            }

            splide.options = {
                drag: isOverflow,
            };
        });


        var progress = splide.root.querySelector('.slider__progress');
        var handle = splide.root.querySelector('.js-collection-carousel-slider');


        // --- 1. Set proportional handle width on mount ---
        splide.on('mounted', function () {
            var end = splide.Components.Controller.getEnd() + 1;
            var rate = Math.min((splide.index + 1) / end, 1);
            handle.style.width = String(100 * rate) + '%';

            updateHandle(); // initial position
        });

        // --- 2. Move handle as slider moves ---
        function updateHandle() {
            var totalSlides = splide.Components.Controller.getEnd();
            var rate = splide.index / totalSlides;

            var trackWidth = progress.offsetWidth;
            var handleWidth = handle.offsetWidth;

            var x = rate * (trackWidth - handleWidth);
            handle.style.transform = `translateX(${x}px)`;
        }

        splide.on('move', updateHandle);
        splide.mount();

        // --- 3. Make handle clickable ---
        progress.addEventListener('click', function (e) {
            var rect = progress.getBoundingClientRect();
            var clickX = e.clientX - rect.left; // where user clicked

            var trackWidth = rect.width;
            var handleWidth = handle.offsetWidth;

            // Center the click relative to handle
            var maxX = trackWidth - handleWidth;
            var x = Math.max(0, Math.min(clickX - handleWidth / 2, maxX));

            var rate = x / maxX;
            var total = splide.Components.Controller.getEnd();
            var index = Math.round(rate * total);

            splide.go(index);
        });

        // --- 4. Make handle draggable ---
        let isDragging = false;

        handle.addEventListener('mousedown', startDrag);
        handle.addEventListener('touchstart', startDrag);

        function startDrag(e) {
            isDragging = true;
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('touchmove', onDrag);
            document.addEventListener('mouseup', endDrag);
            document.addEventListener('touchend', endDrag);
        }

        function onDrag(e) {
            if (!isDragging) return;
            let clientX = e.touches ? e.touches[0].clientX : e.clientX;

            var rect = progress.getBoundingClientRect();
            var trackWidth = rect.width;
            var handleWidth = handle.offsetWidth;

            // Center the handle on the pointer, and clamp it within track bounds
            var maxX = trackWidth - handleWidth;
            var x = Math.max(0, Math.min(clientX - rect.left - handleWidth / 2, maxX));

            var rate = x / maxX;
            var total = splide.Components.Controller.getEnd();
            var index = Math.round(rate * total);

            handle.style.transform = `translateX(${x}px)`;
            splide.go(index);
        }

        function endDrag() {
            isDragging = false;
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('mouseup', endDrag);
            document.removeEventListener('touchend', endDrag);
        }

    });
}